var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(_vm._s(_vm.localTime))])
}
var staticRenderFns = []

export { render, staticRenderFns }